import Vue from 'vue'

const actions = {
  setAll: (context, payload) => {
    context.commit('UPDATE_PROGRESS', payload)
    context.commit('SHOW_DIALOG', payload.showWizardUploadDialog)
    context.commit('SET_SUCCESS_CALLBACK', payload.successCallback)
    context.commit('SET_ERROR_CALLBACK', payload.errorCallback)
    context.commit('SET_BACKGROUND_CALLBACK', payload.backgroundCallback)
  },
  updateProgress: (context, payload) => {
    context.commit('UPDATE_PROGRESS', payload)
  },
  showDialog: (context, payload) => {
    context.commit('SHOW_DIALOG', payload)
  },
}
const getters = {
  getAll: state => state,
  getSuccessFn: state => state.successCallback,
  getErrorFn: state => state.errorCallback,
  getBackgroundFn: state => state.backgroundCallback,
}
const mutations = {
  SHOW_DIALOG: (state, payload) => {
    Vue.set(state, 'showWizardUploadDialog', payload)
  },
  SET_SUCCESS_CALLBACK: (state, payload) => {
    Vue.set(state, 'successCallback', payload)
  },
  SET_ERROR_CALLBACK: (state, payload) => {
    Vue.set(state, 'errorCallback', payload)
  },
  SET_BACKGROUND_CALLBACK: (state, payload) => {
    Vue.set(state, 'backgroundCallback', payload)
  },
  UPDATE_PROGRESS: (state, payload) => {
    Vue.set(state, 'wizardUploadProgress', payload.wizardUploadProgress)
    Vue.set(state, 'wizardUploadMessage', payload.wizardUploadMessage)
  },
}
const state = {
  showWizardUploadDialog: undefined,
  wizardUploadProgress: 0, // Out of 100
  wizardUploadMessage: undefined,
  successCallback: undefined,
  errorCallback: undefined,
  backgroundCallback: undefined,
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
